// -------------------------------------
// #SLICK
// -------------------------------------

jQuery(document).ready(function ($) {
    var prevArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="slick-prev"><use href="#slider-arrow"/></svg>';
    var nextArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="slick-next"><use href="#slider-arrow"/></svg>';

    $("#slick-customers").slick({
        fade: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: "progressive",
        speed: 10000,
        autoplaySpeed: 0,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        variableWidth: true,
        responsive: [
            {
            breakpoint: 640,
                settings: {
                    speed: 7000,
                }
            },
        ]
    });

    $("#slick-review").slick({
        autoplay: true,
        centerMode: true,
        appendArrows: $('#slick-review-arrows'),
        prevArrow: prevArrow,
        nextArrow: nextArrow,               
        focusOnSelect: true, 
        swipeToSlide: true,
        variableWidth: true,
        slidesToShow: 2,
        lazyLoad: "progressive",
    });

    $("#slick-showcase").slick({
        arrows: false,
        autoplay: true,
        centerMode: true,          
        focusOnSelect: true, 
        swipeToSlide: true,
        speed: 7000,
        autoplaySpeed: 0,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        variableWidth: true,
        lazyLoad: "progressive",
        responsive: [
            {
            breakpoint: 640,
                settings: {
                    speed: 5000,
                }
            },
        ]
    });
});
